import { useMemo, useRef } from 'react'
import { uuid4, uuid7 } from '../api/uuid'

/** The ids an op goes with: its mutation's, and the id of what it makes, if anything. */
export interface AttemptIds {
  mutationId: string
  newId: string
}

/**
 * The ids of an op that may be sent again. After a failure, the same op, of
 * the same arguments (`key`), goes again with the same ids: had the server
 * applied it, and its answer been lost on the way, it answers what it
 * recorded, and starts or sends nothing twice. Other arguments, or the same
 * once it was applied (`applied`), make a new op, with new ids.
 */
export function useAttempt() {
  const held = useRef<{ key: string; ids: AttemptIds } | null>(null)
  return useMemo(
    () => ({
      ids(key: string): AttemptIds {
        if (held.current?.key !== key) held.current = { key, ids: { mutationId: uuid4(), newId: uuid7() } }
        return held.current.ids
      },
      applied(): void {
        held.current = null
      },
    }),
    [],
  )
}
